module.exports = __webpack_public_path__ + "static/media/ss.49471e3c.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ss.svg
// module id = 1356
// module chunks = 0